<template>
    <div class="bg-white rounded shadow">
        <header class="flex items-center h-16 px-4 bg-white border-b rounded-t sm:px-6">
            <h3 class="text-base font-normal">Payment Summary</h3>
        </header>

        <chargables-table
            :rents="rents"
            :fees="fees"
        />
    </div>
</template>

<script>
    import ChargablesTable from './chargables-table'

    export default {
        components: {
            ChargablesTable
        },
        props: {
            rents: {
                type: Array,
                required: true
            },
            fees: {
                type: Array,
                required: true
            }
        }
    }
</script>
